import { call, fork, put, takeEvery } from "redux-saga/effects";
import {
  axiosMethods,
  EMessageType,
  toastMessageText,
} from "../utils/appEnums";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_END_POINTS } from "../api/ApiEndPonts";
import { ASYNC_STORAGE_KEY } from "../utils/appconfig";
import { httpRequestFail, httpRequestSuccess } from "./Action";
import ServerCommunicationService from "../api/ServerCommunicationService";
import { all } from "redux-saga/effects";
import { setDataStorage } from "../utils";

const serverCommunicationService = new ServerCommunicationService();

const fetchApiData = async (payload) => {
  const payloadType = payload?.key;
  const methodType = API_END_POINTS[payloadType]?.TYPE;
  const endPoint = API_END_POINTS[payloadType]?.END_POINT;

  
  try {
    let response;
    let finalEndPoint = endPoint;

    console.log(
    "Calling API:",
    methodType,
    endPoint,
    "Payload:",
      finalEndPoint,
    payload?.data,
    payload?.params
  );

  console.log("FORMDATA FILE:", payload?.data?.get("file"));

if (payload?.params) {
  Object.entries(payload.params).forEach(([key, value]) => {
    finalEndPoint = finalEndPoint.replace(`:${key}`, value);
  });
  // console.log("Final End Point after parameter replacement:", finalEndPoint);
}
    switch (methodType) {
      case axiosMethods.GET:

        response = await serverCommunicationService.getDataToServer({
          endPoint: finalEndPoint,
          data: payload?.data,
          params: payload?.params || "",
        });
        console.log("GET API Response:", response);
        break;

      case axiosMethods.POST:
        response = await serverCommunicationService.postDataToServer({
          endPoint: finalEndPoint,
          data: payload?.data,
          params: payload?.params || "",
        });
        console.log("POST API Response:", response);
        break;

      case axiosMethods.PATCH:
        response = await serverCommunicationService.patchDataFromServer({
          endPoint: finalEndPoint,
          data: payload?.data,
          params: payload?.params || "",
        });
        break;

      case axiosMethods.PUT:
        response = await serverCommunicationService.putDataInServer({
          endPoint: finalEndPoint,
          data: payload?.data,
          params: payload?.params,
        });
        break;

      case axiosMethods.DELETE:
        response = await serverCommunicationService.deleteDataFromServer({
          endPoint: finalEndPoint,
          // params: payload?.params,
        });
        break;

      default:
        toast.error({
          type: EMessageType.Error,
          message: toastMessageText.serverError,
          title: "Server Error",
        });
        throw new Error("Invalid method type");
    }
    return response;
  } catch (error) {
    throw error;
  }
};

// Worker Saga
function* httpRequestSaga(action) {
  const { payload } = action || {};
  console.log(">>>>>> PAYLOAD IN SAGA----???", payload);
  try {
    const data = yield call(fetchApiData, payload);
    console.log(">>>>>> DATA FROM SERVER----???", data);

    // ✅ STORE ACCESS TOKEN
    if (data?.data?.user?.accessToken) {
      console.log("Storing accessToken:", data.data.user.accessToken);
  localStorage.setItem("accessToken", data.data.user.accessToken);

      // setDataStorage("accessToken", data.data.user.accessToken);
    }
    if (data?.data?.user?.refreshToken) {
      console.log("Storing refreshToken:", data?.data?.user?.refreshToken);
        localStorage.setItem("refreshToken", data.data.user.refreshToken);


      // setDataStorage(ASYNC_STORAGE_KEY?.refreshToken, {
      //   refreshToken: data?.data?.user?.refreshToken,
      // });
    }

    if (payload?.onSuccess) {
      payload.onSuccess(data);
    }

    // // ✅ success toast
    // if (data?.message) {
    //   toast.success(data.message);
    // }

    yield put(
      httpRequestSuccess({ server_res: data, existing_payload: payload }),
    );
  } catch (error) {
    console.log(">>>>>> EROOR CATCH222222----???", JSON.stringify(error));

    if (payload?.onError) {
      payload.onError(error);
    }
    toast.error({
      type: error?.messageType,
      message: error?.message || toastMessageText.serverError,
      title: "Server Error",
    });

    yield put(
      httpRequestFail({
        server_res: error,
        existing_payload: payload,
      }),
    );
  }
}

// Watcher Saga
function* watchFetchData() {
  yield takeEvery("GET_DATA_FROM_SERVER_API_CALL", httpRequestSaga);
}

export default function* rootSaga() {
  yield all([fork(watchFetchData)]);
}
